import React from 'react';
import { Link } from 'react-router-dom';

import LegalDocumentPage, { Section, SectionTitle } from '../components/LegalDocumentPage';
import { LEGAL, LEGAL_ROUTES } from '../data/legalContent';

const StoragePolicy = () => (
  <LegalDocumentPage
    title="Storage policy"
    description="How FounderDNA stores data on your device. No on-site analytics."
    path={LEGAL_ROUTES.cookies}
    lastUpdated={LEGAL.lastUpdated}
  >
    <Section>
      <p>
        {LEGAL.siteName} is privacy-first. We do <strong>not</strong> use third-party analytics scripts (no Plausible,
        Google Analytics, or similar) on this website. Search performance may be reviewed via Google Search Console,
        which does not place tracking cookies on your browser when you use our site.
      </p>
      <p>
        Read this alongside our <Link to={LEGAL_ROUTES.privacy}>Privacy Policy</Link>.
      </p>
    </Section>

    <Section>
      <SectionTitle>Local storage on your device</SectionTitle>
      <p>
        To provide the assessment and remember your results, we use browser local storage (not advertising cookies).
        Data stays on your device unless you email, export, or share it.
      </p>
      <ul>
        <li><strong>founderDnaResults</strong>: your latest quiz profile and answers</li>
        <li><strong>founderDna_results_history_v1</strong>: previous runs saved locally</li>
        <li><strong>founderDna_checkIns_v1</strong>: weekly check-in entries</li>
        <li><strong>founderDna_emailCaptures_v1</strong>: email addresses you submit on this device</li>
        <li><strong>founderDna_revealSeen</strong> (session): reveal flow state</li>
      </ul>
    </Section>

    <Section>
      <SectionTitle>When you choose to share data</SectionTitle>
      <p>
        If you use <strong>Send my report</strong>, your email and report summary are sent to our email provider (Resend)
        to deliver the message. If paid features are enabled later, payment flows may use Stripe. Those services operate
        only when you initiate them.
      </p>
    </Section>

    <Section>
      <SectionTitle>Clear your data</SectionTitle>
      <ul>
        <li>Use <strong>Delete all local data</strong> in Share &amp; save on your results page</li>
        <li>Clear site data in your browser settings for {LEGAL.siteUrl}</li>
        <li>Email <a href={`mailto:${LEGAL.privacyEmail}`}>{LEGAL.privacyEmail}</a> for privacy requests about data we hold on our servers</li>
      </ul>
    </Section>
  </LegalDocumentPage>
);

export default StoragePolicy;
